import React from 'react';
import { Form, FormItemProps } from 'antd';
import { twMerge } from 'tailwind-merge';

/**
 * Enhanced Form.Item wrapper with consistent styling
 */
const FormItemWrapper: React.FC<
  FormItemProps & { children: React.ReactNode }
> = ({ children, ...props }) => (
  <Form.Item
    className={twMerge('mb-0', props.className)}
    {...props}
    validateFirst
    hasFeedback={false}
  >
    {children}
  </Form.Item>
);

export { FormItemWrapper };
